import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { anyItemIsUnpublishedWorkbook } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { hasExtractRefreshPermission, hasRunNowPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { IDatasourceActions } from '../../../datasource/ServerApi/types/IDatasourceActions';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';
import { IWorkbookActions } from '../../../workbook/ServerApi/types/IWorkbookActions';
import { runExtractRefresh } from '../../actions/extractRefresh/RunExtractRefreshAction';
import { runExtractRefreshNow } from '../../actions/extractRefresh/RunExtractRefreshNowAction';
import {RefreshPropertyHelper} from '../../helpers/RefreshPropertyHelper';

export const RunExtractRefreshEntityAction: IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.runNow_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: runExtractRefresh
};

export const RunExtractRefreshEntityIfRefreshSSSEnabledAction: IEntityAction<IContentInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.runNow_actionSSS,
  isVisible: isVisible,
  isClickable: isClickable,
  createReduxAction: (items: IContentInfo[]) => {
    return runExtractRefreshNow(items);
  }
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[] | IContentInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  const canRefresh = !availableActions || !!(availableActions && availableActions.refreshExtract);
  const hasPermissionToRefresh = hasExtractRefreshPermission(state, spaceItem, availableActions) && hasRunNowPermission(state) &&
  !RefreshPropertyHelper.isDataSourceWithLegacyBridgeSchedule(spaceItem);

  if (anyItemIsUnpublishedWorkbook(tasks)) {
    return false;
  }

  return canRefresh && hasPermissionToRefresh;
}

function isVisible(
  tasks: IExtractTaskInfo[] | IContentInfo[], state: AppState
): boolean {
  // Datasouces specifically cannot be refreshed if they belong to a workbook
  // A datasource is an embeded one iff it has a workbook field that is an object
  const anyEmbeddedDatasources = _.any(tasks, (task: IExtractTaskInfo | IContentInfo) => {
    return task.contentType === 'datasource' && 'workbook' in task && _.isObject(task.workbook);
  });
  if (anyEmbeddedDatasources) {
    return false;
  }
  return FeatureFlags.selfServiceSchedulesForRefreshEnabled && SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
}
